import type { ReactNode } from "react";
import { FOOTER_SOCIAL_LINKS } from "@/components/ui/SocialLinks";
import { HeroNav } from "@/components/ui/hero/HeroNav";
import { Footer } from "@/components/ui/footer";
import logo from "@/assets/mind-media-logo.svg";

const NAVIGATION = [
  { label: "Work", href: "/#work" },
  { label: "About", href: "/#about" },
  { label: "Services", href: "/services" },
  { label: "Pricing", href: "/#pricing" },
  { label: "FAQ", href: "/#faq" },
  { label: "Contact", href: "/#contact" },
];

export function LegalPageShell({
  title,
  lastUpdated,
  children,
}: {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}) {
  return (
    <main className="min-h-screen bg-background">
      <div className="relative isolate z-30 overflow-hidden">
        <div
          aria-hidden
          className="pointer-events-none absolute -left-40 -bottom-40 z-0 h-[420px] w-[420px] rounded-full bg-hero-glow-warm opacity-30 blur-3xl sm:-left-56 sm:-bottom-56 sm:h-[720px] sm:w-[720px] sm:blur-[120px]"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute -right-40 -top-40 z-0 h-[420px] w-[420px] rounded-full bg-hero-glow-cool opacity-35 blur-3xl sm:-right-56 sm:-top-56 sm:h-[720px] sm:w-[720px] sm:blur-[120px]"
        />
        <section className="relative z-20">
          <HeroNav
            logo={<img src={logo} alt="Mind Media" className="h-7 w-auto" />}
            navigation={NAVIGATION}
            ctaButton={{ label: "Book a Meeting", href: "/#contact" }}
          />

          <div className="relative mx-auto max-w-3xl px-6 pt-10 pb-8 text-center sm:pt-14">
            <p className="text-sm font-medium uppercase tracking-widest text-muted-foreground">
              Mind Media
            </p>
            <h1 className="mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
              {title}
            </h1>
            <p className="mt-4 text-sm text-muted-foreground">
              Last updated: {lastUpdated}
            </p>
          </div>
        </section>
      </div>

      <div className="mx-auto max-w-3xl px-6 pb-20 sm:pb-28">{children}</div>

      <Footer
        logo={<img src={logo} alt="Mind Media" className="h-7 w-auto" />}
        brandName="Mind Media"
        socialLinks={FOOTER_SOCIAL_LINKS}
        mainLinks={[
          { href: "/the-problem", label: "The Problem" },
          { href: "/#work", label: "Work" },
          { href: "/#pricing", label: "Pricing" },
          { href: "/#faq", label: "FAQ" },
          { href: "/blog", label: "Blog" },
          { href: "/services", label: "Services" },
        ]}
        legalLinks={[
          { href: "/privacy", label: "Privacy" },
          { href: "/terms", label: "Terms" },
        ]}
        copyright={{
          text: `© ${new Date().getFullYear()} Mind Media`,
          license: "All rights reserved",
        }}
      />
    </main>
  );
}
